import React, { useRef } from 'react';
import DealerStockReportFilters from './components/DealerStockReportFilters';
import DealerStockReportTable from './components/DealerStockReportTable';
import StockLogDialog from './components/StockLogDialog';
import useDealerStockReportData from './hooks/useDealerStockReportData';
import { useLanguage } from '../../contexts/LanguageContext';
import { useLazyExportPartsReturnToExcelQuery } from '../../api/endpoints/dealerStockReport';
import GenericFileExportButton from '../../components/common/GenericFileExportButton';


const DealerStockReportPage = () => {
    const { th } = useLanguage();
    const {
        rows,
        loading,
        totalCount,
        pagination,
        filters,
        onPageChange,
        exportParams,
        filterFields,
        customFilterTypes,
        customFilterOptions,
        handleSearch,
        handleFilterChange,
        handleResetFilters,
        handleApplyFilters,
        logDialogVisible,
        selectedPartCode,
        logRows,
        logLoading,
        logTotalCount,
        logPagination,
        openLogDialog,
        closeLogDialog,
        onLogPageChange
    } = useDealerStockReportData();

    const columnsRef = useRef(null);

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('dealerStockReport.title') || 'Bayi Stok Raporu'}</h1>
                 <GenericFileExportButton
                    useExportQuery={useLazyExportPartsReturnToExcelQuery}
                    exportParams={exportParams}
                    buttonLabel={th("common.export") || "Excel"}
                    buttonClassName="p-button-success"
                    icon="pi pi-file-excel"
                    fileNameExtractor={(result) => result?.fileName || "bayi_stok_raporu.xlsx"}
                    dataExtractor={(result) => result?.fileBase64}
                    contentTypeExtractor={(result) => result?.contentType}
                />
            </div>

            <div className="mb-2">
                <DealerStockReportFilters
                    filterFields={filterFields}
                    columns={columnsRef.current}
                    customFilterTypes={customFilterTypes}
                    customFilterOptions={customFilterOptions}
                    handleSearch={handleSearch}
                    handleApplyFilters={handleApplyFilters}
                    handleResetFilters={handleResetFilters}
                    handleFilterChange={handleFilterChange}
                />
            </div>

            <DealerStockReportTable rows={rows} loading={loading} totalCount={totalCount} pagination={pagination} onPageChange={onPageChange} filters={filters} onShowLogs={(row) => openLogDialog(row?.partCode)} columnsRef={columnsRef} />

            <StockLogDialog visible={logDialogVisible} onHide={closeLogDialog} partCode={selectedPartCode} rows={logRows} loading={logLoading} totalCount={logTotalCount} pagination={logPagination} onPageChange={onLogPageChange} />
        </div>
    );
};

export default DealerStockReportPage;
